module.exports = __webpack_public_path__ + "common/icon-arrow-white-1a6b5d397e05c8b59275730eb81522c0.svg";